import { Application } from '@hotwired/stimulus';
import { Injector, NgModule } from '@angular/core';
import JsonOptionsController from "./controllers/json-options.controller";
import { OpSharedModule } from "core-app/shared/shared.module";

declare global {
  interface Window {
    Stimulus:Application;
  }
}

@NgModule({
  declarations: [],
  imports: [
    OpSharedModule,
  ],
})
export class PluginModule {
  constructor(injector:Injector) {
    window.Stimulus.register('json-options', JsonOptionsController);
  }
}
